{
  "faq": {
    "faqListGeneral": [
      {
        "id": 0,
        "title": "What is {{productName}}?",
        "body": "{{productMessage}} gives you the freedom to purchase what you want now and pay over time with simple fixed installments. Some plans include interest while some are interest-free.<br><br>When you’re ready to check out, just select <strong>{{productName}}</strong> as your payment method, complete a short application, and receive a quick decision. Choose the terms of your payment plan, finish checking out, and enjoy your purchase. Then, pay over time with simple, no-surprise monthly payments."
      },
      {
        "id": 1,
        "title": "Is this an installment loan?",
        "body": "Yes, all loans through {{productName}} are installment loans, which means you repay the loan over time with a set number of scheduled payments. Some plans include interest while some are interest-free. Your payments are the same amount over the life of the loan and you can pay off your loan at any time without paying a penalty or fee."
      },
      {
        "id": 2,
        "title": "Can I finance travel on behalf of someone else?",
        "body": "With some merchants, you can use {{productName}} to purchase travel on behalf of someone else. A travel provider who has enabled this feature will be indicated with a dropdown option for “new applicant” during the application process. This option is not available in Canada."
      },
      {
        "id": 3,
        "title": "I purchased a trip using {{productName}}, can I travel before it's paid off?",
        "body": "Yes! You do need to allow a few days between booking and your departure date for things to process. Other than that, you are free to travel whenever - even before you're all paid off."
      },
      {
        "id": 4,
        "title": "How do I cancel/return my purchase? ",
        "body": "Contact the merchant directly to return your purchase. If your return is accepted, the merchant will send us the refund and we will apply the amount of your refund to the balance of your loan. If you receive a credit rather than a refund or are charged a cancellation fee, you will still be responsible for the outstanding balance. If the refunded amount is more than your outstanding balance, we refund that money to you."
      }
    ],
    "faqListPayments": [
      {
        "id": 0,
        "title": "How are my loan term offers determined?",
        "body": "We look at a number of factors, including your credit information, purchase details, and more."
      },
      {
        "id": 1,
        "title": "Can I make additional payments?",
        "body": "Yes, you can make additional payments to pay down your balance or pay off your purchase in full. You can pay off your loan at any time without paying a penalty or fee. <br/><br/>Making additional payments won't change your monthly payment amount, but it will pay off your loan sooner and decrease the total amount of interest you pay over the life of your loan."
      },
      {
        "id": 2,
        "title": "When are my payments due?",
        "body": "Payments are due monthly. Your due date is available in your account at {{paymentWebsite}}. We'll also send you emails and text messages to remind you."
      },
      {
        "id": 3,
        "title": "What are my payment method options?",
        "body": "Customers from Canada can pay by direct debit from their bank account, Visa/MasterCard virtual debit, or cheque.  <br/><br/>We recommend linking your bank account via Plaid to make effortless, electronic payments. Plaid ensures your information is always secure and up-to-date and you never have to worry about lost or stolen cards. If paying by cheque, please make your cheque payable to {{payableCompanyName}}, and send to our Canada office address: <br/><br/>{{payableCompanyAddressName}} <br/>{{fullAddress}}"
      },
      {
        "id": 4,
        "title": "How do I make installment payments?",
        "body": "You can make a payment anytime by visiting {{paymentWebsite}} and clicking on the Loans tab. From there, click the Make a Payment button. <br/><br/>We recommend that you enable AutoPay at time of purchase so that your payments are automatically deducted each month. <br/><br/>If you don’t have AutoPay enabled, visit {{paymentWebsite}}, click on the Accounts page, and set the AutoPay toggle to ON. <br/><br/>You can also change the form of payment on file with {{productName}} anytime by visiting {{paymentWebsite}}."
      }
    ]
  },
  "buttons": {
    "back": {
      "label": "Back"
    }
  },
  "header": "Frequently Asked Questions"
}
